<div class="mt-5">
   <h6>Composizioni</h6>
   <div class="add-lessons-form mt-7" [formGroup]="composizioneFrm">
      <ng-container formArrayName="composizioni" *ngFor="let composizione of composizioni.controls; let i = index">
         <div class="grid grid-cols-3 gap-3" [formGroupName]="i">
            <mat-form-field appearance="fill">
               <mat-label>Percentuale</mat-label>
               <input matInput type="number" formControlName="percentuale" (change)="changePerc()"
                      class="no-scroll">
               <span matSuffix>%</span>
               <mat-error *ngIf="composizione?.controls.percentuale.errors">
                  la percentuale è <strong>obbligatoria</strong>
               </mat-error>
            </mat-form-field>

            <mat-form-field appearance="fill">
               <mat-label>Tessuto</mat-label>
               <mat-select formControlName="tessuto" placeholder="Tessuto">
                  <mat-option *ngFor="let tessuto of tessuti" value="{{tessuto.data.id}}">
                     {{tessuto.data.nome}}
                  </mat-option>
               </mat-select>
               <mat-error *ngIf="composizione?.controls.tessuto.errors">
                  Il tessuto è <strong>obbligatorio</strong>
               </mat-error>
            </mat-form-field>

            <div class="mt-4">
               <button (click)="clickEliminaFormGroup(i, composizione)"
                       color="warn"
                       mat-raised-button
                       matTooltip="Elimina composizione"
                       matTooltipPosition="above"
                       aria-label="Elimina composizione">
                  <mat-icon>delete</mat-icon>
                  Elimina
               </button>
            </div>
         </div>
      </ng-container>

      <button appDebounceClick [debounceTime]="500" *ngIf="composizioni.length > 0" [disabled]="tot_perc != 100"
              mat-raised-button class="bg-amber-400" (debounceClick)="clickSaveComposizione()">Salva composizione</button>
   </div>
</div>

<div class="mt-10">
   <h6>Categorie</h6>
   <div class="my-7">
      <div class="add-lessons-form" [formGroup]="categoriaFrm">
         <ng-container formArrayName="categories"  *ngFor="let category of categorieArray.controls; let index = index">
            <div class="grid grid-cols-1" [formGroupName]="index">
               <mat-form-field appearance="fill">
                  <mat-label>Categoria</mat-label>
                  <mat-select formControlName="categoria"
                              (valueChange)="clickChangeCategories($event, index + 1)"
                              [placeholder]="'Categoria'">
                     <mat-option *ngFor="let categoria of catArray[index]"
                                 value="{{categoria.data.id}}">
                        {{categoria.data.nome}}
                     </mat-option>
                  </mat-select>
               </mat-form-field>
            </div>
         </ng-container>
         <button *ngIf="!categoriaProdottoId" mat-raised-button class="bg-amber-400" (click)="clickSaveCategoria()">Salva categoria</button>
         <button appDebounceClick [debounceTime]="500" *ngIf="categoriaProdottoId" mat-raised-button class="bg-amber-400" (debounceClick)="clickEditCategoria()">Modifica categoria</button>

      </div>
   </div>
</div>
